export enum StatisticId {
    TotalMoneyGained = "total-money-gained",
}